import type { VoidFunctionComponent } from 'react';
import styles from '../../ReportGenerationV2.module.less';
import SidebarNav from '../../../../../generic/SidebarNav';
import type { ReportCategory } from '../../../shared/types';
import { useCanDisplaySecurityOptions } from '../../../hooks';
import { useLocation } from '../../../../../../contexts/RouterContext';
import { useIsFeatureEnabled } from '../../../../../../helpers/features';
import { FIX_PLAN_REPORT } from '../../../../../../../shared/featureFlags/flagNames';
import { ReportCategories } from '../../../ReportGeneration/utils';

type Props = {
  reportType: ReportCategory | 'settings';
  url: string;
  resetFormat: () => void;
};

const Sidebar: VoidFunctionComponent<Props> = ({ url, reportType, resetFormat }: Props) => {
  const shouldDisplayVulnReport = useCanDisplaySecurityOptions();
  const location = useLocation();
  const isSettingsActive = location.pathname.includes('settings');
  const shouldDisplayFixPlan = useIsFeatureEnabled(FIX_PLAN_REPORT);

  return (
    <span className={styles.sidebar}>
      <SidebarNav>
        <SidebarNav.Heading>Reports</SidebarNav.Heading>
        <SidebarNav.Item
          onClick={resetFormat}
          isActive={reportType === ReportCategories.Licensing}
          to={`${url}/${ReportCategories.Licensing}`}
        >
          Licensing
        </SidebarNav.Item>
        <SidebarNav.Item
          onClick={resetFormat}
          isActive={reportType === ReportCategories.SBOM}
          to={`${url}/${ReportCategories.SBOM}`}>
          SBOM
        </SidebarNav.Item>
        {shouldDisplayVulnReport && (
          <SidebarNav.Item
            onClick={resetFormat}
            isActive={reportType === ReportCategories.Vulnerability}
            to={`${url}/${ReportCategories.Vulnerability}`}>
            Vulnerabilities
          </SidebarNav.Item>
        )}
        {shouldDisplayFixPlan && (
          <SidebarNav.Item
            onClick={resetFormat}
            isActive={reportType === ReportCategories.FixPlan}
            to={`${url}/${ReportCategories.FixPlan}`}>
            Fix Plan
          </SidebarNav.Item>
        )}
        <SidebarNav.Item onClick={resetFormat} isActive={isSettingsActive} to={`${url}/settings`}>
          Settings
        </SidebarNav.Item>
      </SidebarNav>
    </span>
  );
};

export default Sidebar;
